/* eslint-disable import/prefer-default-export */
import * as React from 'react';
import { SpinningLoader } from 'Icons/Animated/SpinningLoader';
import styles from './loading-content.module.css';

interface LoadingSpinnerProps {
    qaDataTag?: string;
    height?: number;
    lowProfile?: boolean;
    withMarginTop?: boolean;
    withMarginBottom?: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
    qaDataTag = 'loading-content-component',
    lowProfile = false,
    withMarginTop = true,
    withMarginBottom = true,
    height,
}: LoadingSpinnerProps): React.ReactElement => (
    <div
        style={{
            height: height ? `${height}rem` : 'auto',
            margin: '0',
            marginTop: withMarginTop ? '1rem' : '0',
            marginBottom: withMarginBottom ? '1rem' : '0',
            padding: lowProfile ? '1rem' : '2rem',
        }}
        className={styles.LoadingContent}
        data-testid={qaDataTag}
    >
        <SpinningLoader aspect="1.5rem" />
    </div>
);
